import DeliveryConfirmation from './DeliveryConfirmation.enum';

export default Object.freeze([
	{
		key: 'AdultSignature',
		label: 'Adult Signature Required',
		tooltip:
			'Requires the signature of any person 21 years of age or older at the recipients address.',
		value: DeliveryConfirmation.AdultSignature,
	},
	{
		key: 'DirectSignature',
		label: 'Direct Signature Required',
		tooltip: 'Requires the signature of any person at the recipients address.',
		value: DeliveryConfirmation.DirectSignature,
	},
	{
		key: 'DeliveryConfirmationMailed',
		label: 'Delivery Confirmation Mailed',
		tooltip:
			'Provides tracking updates and UPS will mail you a confirmation of delivery without a signature.',
		value: DeliveryConfirmation.DeliveryConfirmationMailed,
	},
	{
		key: 'None',
		label: 'None',
		tooltip: 'No tracking updates for the item.',
		value: DeliveryConfirmation.None,
	},
	{
		key: 'Signature',
		label: 'Signature Required',
		tooltip: 'Requires the signature of any person at the recipients address.',
		value: DeliveryConfirmation.Signature,
	},
	{
		key: 'Tracking',
		label: 'USPS Tracking',
		tooltip: 'Provides tracking updates as an item travels to its destination.',
		value: DeliveryConfirmation.Tracking,
	},
]);
